export default __webpack_public_path__ + "static/media/cachgiac.7f92d4df.png";